export default {
  navbar: {
    index: '首页',
    duty: '社会责任',
    center: '产品中心',
    advanced: 'SIP先进封装',
    solve: '解决方案',
    about: '关于我们'
  },
  prod: {
    save: '存储部件',
    dd: '2.5D/3D晶圆级封装',
    fz: 'SIP先进封装',
    xl: 'WBBGA系列封装'
  },
  jx: {
    jx0: '智能终端主流闪存解决方案',
    jx1: '移动储存应用',
    jx2: '先进封装更高集成度',
    jx3: '赋能移动终端畅快体验',
    jx4: '先进封装高性能',
    jx5: '新一代高速大容量存储芯片',
    jst: 'CENLAK SD卡'
  },
  CpList: {
    cp1: 'PC应用',
    cp2: '行业终端应用',
    cp3: '数据中心应用',
    cp4: '智能终端应用',
    cp5: '智能汽车应用',
    cp6: '移动储存应用',
  },
  aboutList: {
    ab1: '公司简介',
    ab2: '荣誉资质',
    ab3: '核心优势',
    ab4: '经典案例',
    ab5: '新闻动态',
    ab6: '社会责任',
    ab7: '人才招聘',
    ab8: '联系我们',
  },
  Dat: {
    hq: '总部',
    hqInName: '（总部）',
    tel: '电话',
    email: '邮箱',
    mapTip: '地图暂时没有加载出来',
    mapOpen: '在百度地图中查看该地点',
    name1: '浙江甚湖科技有限公司',
    name2: '浙江省湖州市吴兴区织里镇鹏飞路1866号4号楼',
    short1: '湖州总部',
    name3: '甚湖科技-上海分部',
    name4: '上海市自贸试验区临港新片区环湖西二路888号C楼',
    short3: '上海',
    name5: '甚湖科技-苏州分部',
    name6: '江苏省苏州市高新区绿宝休闲购物广场2幢12005-V08室',
    short5: '苏州',
    name7: '甚湖科技-杭州分部',
    name8: '浙江省杭州市滨江区西兴街道聚业路25号1幢26楼',
    short7: '杭州',
    name9: '甚湖科技-深圳分部',
    name10: '广东省深圳市龙岗区李朗社区宝泰大厦18楼1810室',
    short9: '深圳',
  },
  cus: {
    policy1: '环境保护',
    policy2: '合作共赢',
    policy3: '创新成就',
    policy4: '守正经营',
    poilxb1: '甚湖科技注重环境保护，致力于打造绿色环境，做到节约资源，减少污染，有效利用废物，树立环保意识，使企业的可持续发展步伐变得更加迅速。',
    poilxb2: '甚湖科技具备科学有效的企业管理制度，持续落实保障企业中的劳工权益、人权、职业健康和安全等领域，积极履行社会责任。',
    poilxb3: '企业创新精神是企业发展的归宿，高品质产品从来不是潦草应付的结果，甚湖科技用心聆听消费者心声，及时识辨、精准把握，使产品与服务质量不断提升，真正赢得市场青睐。',
    poilxb4: '我们倡议所有企业坚守诚信经营的原则，严格遵守国家法律法规和商业道德规范，始终如一地履行合同义务，不欺骗、不欺诈、不误导消费者，以实际行动维护市场秩序和公平竞争。',
    gy1: '教育扶贫：为贫困地区孩子创造更多机会！',
    gy2: '教育扶贫是为了贫困地区的孩子提供更多的受教育机会，使他们能够脱离贫穷，实现自己的理想。',
    gy3: '教育扶贫：为贫困地区孩子创造更多机会！',
    gy4: '教育扶贫是为了贫困地区的孩子提供更多的受教育机会，使他们能够脱离贫穷，实现自己的理想。',
    ygbt1: '为呵护全体职工健康，甚湖科技组织全体员工进行健康体检活动，近百余名员工参与',
    ygbt2: '开展春季团建活动，旨在通过团队的聚集与激情，进一步推动公司的发展和壮大',
    ygbt3: '开展了企业分享会,这次会议旨在让员工更深入了解公司',
    cus0: '先进封测及完善的配套能力',
    cus1: '浙江甚湖科技有限公司是一家提供高端芯片封测服务的方案商。公司具有数百项目的高端复杂、高算力/SiP芯片封装项目管理和交付经验，服务超过八十多的国内客户。',
    cus2: '公司先进封装测试设备350套，已建立一套完整的封装设计标准、生产管控流程，质量保证体系，配备先进规模化的加工&测试产线。公司与产业链保持良好的合作关系。公司秉承“品质为本，勇于创新”的理念，致力于为客户提供卓越的产品和服务。',
    cus3: '为了契合消费者对于智能终端轻薄化、高性能以及低功耗的要求。在智能家居中，可实现设备的互联互通和智能控制；在工业自动化中，助力实现精准的数据采集和高效的生产控制；在医疗设备中，为医疗影像、生命体征监测等提供强大的计算支持。',
    cus6: '对于国产 PC 品牌商、PC OEM 厂商以及装机商等 PC 前装市场，甚湖品牌主要供应消费级的固态硬盘与内存条等产品。依靠长期的技术研发沉淀以及智能化的生产测试系统，其相关产品顺利通过了 PC 行业龙头客户极为严格的预装导入测试，在性能、可靠性、兼容性等方面均达到了一定的水平。',
    cus9: '甚湖存储始终专注于为服务器、工作站等企业级应用，提供多种存储产品。这些产品以大容量、多接口、多规格的特点，打造出数据高速存储方案，能够支持服务器的高效运转。它们具备高可靠度、低功耗、长使用寿命以及低拥有成本等优势，数据的可访问性和可用性增强。',
    cus12: '在智能终端领域有广泛应用。例如，在智能手机中，其芯片可为多任务处理、大型游戏运行和高清视频播放提供流畅体验；在平板电脑里，能确保快速响应和出色的图形处理能力；在可穿戴设备上，助力实现精准健康监测和实时消息推送等功能。',
    cus15: '在车载行业的多个关键领域都有着重要且广泛的应用，应用于车载信息娱乐系、自动驾驶领域、车辆的动力控制和能源管理等方面，都有身影。为汽车的智能化、高效化和安全化发展提供了有力的技术支撑。',
    cus18: '移动存储领域其主控芯片采用先进制程，具有读写速度快、数据纠错能力强等特点，可应用于存储卡、存储盘等产品，为用户带来高速、稳定的存储体验。',
    ab5: '传统',
    ab6: '甚湖',
    ab7: '引线键合式',
    ab8: '将芯片的有源区面朝上，背对基板贴装键合。',
    ab9: '倒装式',
    ab10: 'FlipChip指的是芯片倒装，将芯片有源区面对着基板，通过芯片上呈阵列排列的焊料凸点（Bumping）实现芯片与基板的互联。',
    ab11: '传统的晶圆级封装（Fan-in WLP），其I/O数受到芯片面积限制，适用于低引脚数的消费型集成电路封装。',
    ab12: '使用Fan-out可以增加了I/O数目，同时采用RDL层布线大幅降低整体封装厚度。',
    ab13: '2.5D/3D晶圆封装',
    ab14: '2.5D/3D封装技术，可以进行高度集成，使得封装更加小型化和高性能化。',
    ab17: '先进封装可通过 2.5D/3D 封装等技术实现芯片高密度和微系统高互连速度，利用 SiP 打造异构集成，为不同芯片和组件提供灵活性，提升 AI 算力，满足 AIGC 需求。',
    ab18: '为提升芯片集成度和效能提供了更多解决方案，进而有助于实现 8K 分辨率所需的高性能和高功能密度。',
    ab19: '先进封装在 AR/MR 领域能实现芯片的高密度集成，提升性能并降低功耗，还可优化传感器与处理器的连接，提高数据传输速度，助力增强现实和混合现实体验。',
    ab20: 'AI for Science 的发展，对芯片算力的需求日益增长。在后摩尔时代，传统芯片制程在进一步微缩上遇到困难且成本高昂，先进封装逐渐成为推动 AI 产品变革的关键技术之一。',
    ab21: '计算生物领域通常需要处理大量的数据和进行复杂的计算，这对芯片的性能和功耗有较高要求。先进封装有助于突破芯片的“面积墙”和“功耗墙”等限制',
    ab22: '先进封装愿景',
    ab23: '技术创新',
    ab24: '质量与可靠性',
    ab25: '客户服务',
    ab26: '可持续发展',
    ab27: '人才培养与团队建设',
    ab28: '行业影响力',
    ab29: '致力于研发前沿的封装技术，如 3D 封装、晶圆级封装等。投入资源进行新材料和新工艺的研究，以突破现有封装的性能限制。',
    ab30: '追求零缺陷的封装质量，建立严格的质量控制体系。确保封装产品在各种复杂环境下的高可靠性和稳定性。',
    ab31: '以客户需求为导向，提供定制化的封装解决方案。与客户建立长期合作伙伴关系，共同应对市场挑战。',
    ab32: '注重环保，采用绿色封装材料和节能生产工艺。推动产业的可持续发展，为社会和环境做出积极贡献。',
    ab33: '吸引和培养封装行业顶尖人才，打造创新、高效的团队。营造良好的企业文化，促进员工的个人成长和职业发展。',
    ab34: '成为先进封装领域的标准制定者和技术引领者。积极参与行业交流与合作，提升企业在全球封装市场的影响力。',
    ab39: '计算生物',
  },
  solution: {
    index: '按应用方向',
    zl: '智能“芯”方案，开启未来篇',
    bl0: '应用方向',
    bl1: 'PC应用',
    bl2: '数据中心应用',
    bl3: '智能终端应用',
    bl4: '智能汽车应用',
    bl5: '移动储存应用',
    bl6: '行业终端应用',
    bl7: '对于国产 PC 品牌商、PC OEM 厂商以及装机商等 PC 前装市场，甚湖品牌主要供应消费级的固态硬盘与内存条等产品。依靠长期的技术研发沉淀以及智能化的生产测试系统，其相关产品顺利通过了 PC 行业龙头客户极为严格的预装导入测试，在性能、可靠性、兼容性等方面均达到了一定的水平。',
    bl8: '',
    bl9: '芯片的不断发展和创新为数据中心提供了强大的计算能力、高效的存储和快速的通信，是支撑数据中心运行和发展的关键基础。',
    bl10: '随着行业竞争加剧，消费电子产品更新迭代不断加快，产品智能化迈向新高度。',
    bl11: '存储产品已经广泛应用于智能手机、平板电脑、智能穿戴等智能终端市场，为消费者提供更有品质的电子消费体验。',
    bl12: '汽车芯片素有“汽车的神经”之称，是汽车不可或缺的关键原件。',
    bl13: '伴随汽车智能化的趋势愈发强烈，诸如语音识别、手势交互、网络联接、自动驾驶等功能接连出现，这极大地提高了汽车对于芯片数量以及性能的需求。',
    bl14: '随着数字化信息的爆炸式增长，人们对于移动存储设备的容量需求不断攀升。',
    bl15: '高性能的芯片能够实现更高的存储密度，满足用户存储大量照片、视频、文档等数据的需求。',
    bl16: '于工业，能精准控制生产提升效率；在医疗，保障数据精准处理助于诊断；金融中加速交易并确保安全；交通里实现智能调度与安全运行；能源领域优化管理与利用。',
    bl17: '芯片是各行业创新与发展的关键支撑。',
  },
  lu: {
    li1: '中央处理器（CPU）',
    li2: '作为电脑的核心运算部件，负责执行各种指令和数据处理，决定了电脑的整体性能和运行速度。',
    li3: '图形处理器（GPU）',
    li4: '图形渲染和图像处理的任务，对于游戏、图形设计、视频编辑等需要高质量图形显示的应用至关重要。',
    li5: '内存芯片（如 DDR4、DDR5 等）',
    li6: '用于存储正在运行的程序和数据，其速度和容量直接影响系统的响应能力和多任务处理能力。',
    li7: '存储芯片（如固态硬盘 SSD 中的闪存芯片）',
    li8: '供了数据的长期存储，高速的 SSD 能显著加快系统启动和数据读取速度。',
    li9: '负责处理和执行各种复杂的计算任务，如数据处理、应用运行和任务调度等，对数据中心的整体运算能力和性能起着决定性作用。\n',
    li10: '在深度学习、人工智能训练和图像处理等任务中表现出色，能够加速大规模数据的并行计算，提高数据处理效率。',
    li11: '专用集成电路（ASIC）',
    li12: '对特定的应用需求进行定制设计，例如加密货币挖矿、数据压缩等，能够提供高效的、专门化的处理能力。',
    li13: '现场可编程门阵列（FPGA）',
    li14: '具有可编程性和灵活性，适用于快速开发和优化特定的算法和功能，常用于加速网络处理、数据分析等任务。',
    li15: '智能手机',
    li16: '央处理器（CPU）芯片负责运行操作系统和各种应用程序，决定了手机的运行速度和多任务处理能力。图形处理器（GPU）芯片为游戏、视频播放和图形界面提供流畅的视觉效果。基带芯片则负责手机的通信功能，实现与移动网络的连接和数据传输。',
    li17: '平板电脑',
    li18: '强大的 CPU 和 GPU 芯片保证了其性能和显示效果，同时存储芯片确保了有足够的空间来存储文件和应用。\n',
    li19: '智能手表',
    li20: '处理传感器数据，如心率监测、运动追踪等，同时实现与手机的连接和信息同步。',
    li21: '智能家居设备',
    li22: '音处理芯片来识别和理解用户的语音指令，并通过网络芯片与云端服务器进行通信，以获取回答和执行相关操作。如智能摄像头、智能门锁等，芯片不仅负责数据处理和功能实现，还能保障设备在低功耗状态下稳定运行。',
    li23: '控着智能汽车的整体运算和系统控制，确保车辆的各种功能有序运行。',
    li24: '图像识别芯片',
    li25: '自动驾驶系统中发挥关键作用，能够快速准确地识别道路状况、交通信号和其他车辆行人等。',
    li26: '传感器芯片',
    li27: '收集车辆周围的环境信息，如温度、湿度、压力等，为车辆的智能决策提供数据支持。',
    li28: '车载系统系统',
    li29: '为乘客提供丰富的多媒体体验，包括高清视频播放、音频处理等，还负责车辆与外部世界的稳定连接，实现车与车、车与基础设施之间的信息交互。',
    li30: '闪存芯片',
    li31: '移动存储设备（如 U 盘、移动硬盘等）的核心组件之一。它能够快速地写入和读取数据，确保用户可以高效地存储和传输文件。',
    li32: '固态硬盘',
    li33: '管理数据的读写操作、纠错以及与主机系统的通信，从而提升移动存储设备的性能和稳定性。',
    li34: '存储卡（如 SD 卡、microSD 卡）',
    li35: '能够在小尺寸的卡片中提供大容量的存储空间，满足移动设备（如相机、手机等）对存储扩展的需求。',
    li36: '工业制造行业',
    li37: '精准的控制和实时监测是确保生产流程高效、稳定和高质量的关键。芯片能够为各类工业设备提供强大的运算能力和快速的响应速度，实现精确的生产控制和故障预警，从而提高生产效率、降低次品率。',
    li38: '医疗行业',
    li39: '从先进的医疗影像设备到便携式的诊断工具，芯片对于准确获取、处理和传输患者的生理数据至关重要。高质量的芯片可以提升设备的分辨率和检测精度，为医生提供更准确的诊断依据，有助于疾病的早期发现和治疗。',
    li40: '金融行业',
    li41: '交易处理的速度和安全性直接影响着市场的稳定和客户的信任。芯片能够加速交易处理，保障数据的加密传输和存储，防范金融欺诈和数据泄露，确保金融业务的高效、安全运行。',
    li42: '交通运输行业',
    li43: '无论是智能交通系统中的车辆监控和调度，还是航空航天领域的飞行控制和导航，芯片都扮演着不可或缺的角色。它们能够实时处理大量的传感器数据，保障交通工具的安全运行和高效调度。',
    li44: '能源行业',
    li45: '芯片有助于实现能源生产和分配的智能化管理，提高能源利用效率，优化能源存储系统的性能，促进可再生能源的整合和利用。'
  },
  xd: {
    check: '全部产品',
    bt: '嵌入式储存芯片，记忆无忧',
    zx: '资讯',
    look: '查看更多',
    cp: '产品规格',
    lj: '了解详情',
    fa: '全部方案',
    yy: '应用方向',
    tj: '推荐产品',
  },
  prods: {
    in1: 'SSD工程师',
    in2: 'Molding工艺工程师',
    in3: 'WB工程师',
    zw1: '模组事业部',
    zw2: '本科',
    zw3: '电子电气、通信工程专业',
    yq1: '具有固态硬盘产品应用，技术支持或新产品导入的经验，熟悉国产SSD方案，有从事SSD产品设计经验者优先。\n',
    yq2: '1、3年以上Molding，相等关制程工作经验；\n',
    yq3: '2、具有良好的分析、解决问题的能力；\n',
    yq4: '3、英语读写能力熟练，口语佳者优先；\n',
    yq5: '4、熟悉TOWAY-1E设备的优先考虑。\n',
    yq6: '1、责任心强，拥有半导体封装行业两年以上工作经验;',
    yq7: '2、熟悉Shikawa新川焊线机UTC3000 UTC5000优先。',
    rzyq: '任职要求',
    ymy: '元/月',
    yggh: '员工关怀'
  },
  hj: {
    hj1: '宽温nand flash封良率的极大提升',
    hj2: '普通0°~70°C属于商用产品对闪存颗粒的温度要求，我们改善工艺、塑封材料配比，逐步实现了宽温：',
    hj3: '-20°~85°C，工规',
    hj4: '-50°~125°C；特种宽温',
    hj5: '在严苛的使用环境下验证各等级闪存颗粒的正常使用，已经获得相关用户的批量验证；批产良率极大提升。',
    hj6: '-40°~95°C，工规2级',
    hj7: '先进封测在嵌入式存储芯片的实列',
    hj8: 'EMMC的两个难点，在先进封装基础上得以解决，有效提升良率：',
    hj9: '封测出批量合格的宽温芯片，而不是封测之后的无保障的筛选；',
    hj10: '系统级封装：主控+加密芯片+nand晶圆+阻容感芯片，符合用户要求的多功能芯片封装。',
    hj11: '两个问题，都是在先进封装的基础上完成，集合了团队多年封测经验，尤其是在良率的提升上有重要意义。',
    hj12: 'UFS 容量的提升，从128GB，256GB，512GB，1TB，2TB，逐步提升',
    hj13: 'UFS2.2/3.1/4.0，在SMI方案商支持下，我们封测在高新能嵌入式存储产品的容量和传输速度提升。多叠带工艺、FCBGA、SIP、Chiplet综合应用，为我们服务更多优秀企业成为可能。'
  },
  about: {
    bout1: '公司简介',
    bout2: '荣誉资质',
    bout3: '核心优势',
    bout4: '经典案例',
    bout5: '新闻动态',
    bout6: '社会责任',
    bout7: '人才招聘',
    bout8: '联系我们',
    bout9: '合作客户',
    bout10: '合作供应商',
    tx1: '团队具备20年专业经验，预研、打样、批量交付快速',
    tx2: '核心的研发厂商合作，国际顶尖软硬件团队合作，长期驻厂支持',
    tx3: '品牌客户多年合作经验，严选大客户持续配套出货中',
    tx4: '强大资金后盾，充足的产能供应',
    tx5: '智能“芯”，智慧生活',
  },
  careers: {
    heroTitle: '选择合适你的方式，加入我们',
    heroDesc: '无论你是寻找心仪的职位，还是希望展示你的独特才华，我们都期待你的加入。',
    jobTitle: '职位招聘',
    jobDesc: '查看最新岗位信息，寻找合适你的机会',
    resumeTitle: '自荐留言',
    resumeDesc: '如果你有一技之长，欢迎通过问卷向我们展示你的才华',
    resumeTipTitle: '自荐留言即将上线',
    resumeTipDesc: '该功能正在开发中。在此之前，欢迎直接发送简历或自荐材料到下面的邮箱，我们会尽快与你联系。',
    resumeTipMail: '投递邮箱',
    resumeTipClose: '我知道了',
    listTitle: '职位招聘',
    value1: '开放包容，多元团队',
    value2: '持续成长，广阔团队',
    value3: '创新驱动，共同发展',
    value4: '以人为本，成就未来',
  },
  bt: {
    bt0: '精选产品',
    bt1: '6大终端应用',
    bt2: '公司介绍',
    bt3: '新闻资讯',
    bt4: '可持续发展方针',
    bt5: '公益慈善',
    bt6: '员工关怀',
    bt7: '了解甚湖先进封装',
    bt8: '技术优势',
    bt9: '产品介绍',
    bt10: '产品案例',
    bt11: '先进封装愿景',
    bt12: '合作客户',
    bt13: '合作供应商',
  },
  information: {
    in0: '浙江省湖州市吴兴区织里镇鹏飞路1866号4号楼'
  },
  introduction: {
    line: ' 浙江甚湖科技有限公司是全球领先的存算一体先进封装技术解决方案提供商。公司凭借在存储与计算领域的深厚积累，结合先进的封装技术，专注于实现产品的小型化与低功耗，驱动存算一体的发展，使“万物皆可存算”成为可能，引领半导体行业的技术革新与产业升级。',
    line1: '公司产品及服务涵盖嵌入式存储、工控存储、消费者存储与先进封测服务，广泛应用于移动存算、智算中心、车规工控、消费电子等技术领域。我们致力于自主创新，推动全链条国产替代，打破国际技术壁垒。扎根湖州，放眼全球，甚湖科技以高端人才、先进管理和顶尖设备为基石，持续打造强劲“芯动力”。',
    line2: '我们的愿景是成为全球领先的存算芯片创新解决方案提供商，让存算更便捷、数据更安全，为行业发展注入新活力，实现万物皆可存算的未来。',
  },
  newsArticle: {
    lead: '导语',
    summaryLead: '结语'
  },
  new: [
    {
      img: '../assets/spec/news1016_1.png',
      time: '2026-10-16',
      bt: '智启广交盛会 存储链接全球—浙江甚湖科技亮相第 140 届广交会',
      js: '10月16日至17日，第140届中国进出口商品交易会在广州启幕。浙江甚湖科技有限公司作为深耕存储芯片封装与智能制造赛道的国家高新技术企业，由常务副总经理王微女士带队参展，携全系列存储创新产品与一站式存储解决方案亮相……',
      route: '/newsdetail/cantonFair'
    },
    {
      img: '../assets/spec/news0917_1.png',
      time: '2026-09-17',
      bt: '浙江甚湖科技赴绵阳考察，计划落地FC、SOP及陶瓷封装产线',
      js: '2026年9月17日，浙川东西部协作产业链供应链合作绵阳活动暨知名浙江企业绵阳行产业合作恳谈会在四川绵阳举行。浙江甚湖科技总经理葛庆随浙江企业家考察团赴绵阳，深度开展实地调研与政企对接，计划在绵阳布局扩展 FC、SOP 及陶瓷封装产线……',
      route: '/newsdetail/mianyang'
    },
    {
      img: '../assets/spec/news0317_1.png',
      time: '2026-03-17',
      bt: '重磅合作|甚湖科技携手行业龙头，共绘智能制造新蓝图',
      js: '本周，浙江甚湖科技有限公司迎来了立讯精密工业股份有限公司（股票代码：002475）莅临我司考察调研，并就深度合作达成重要共识……',
      route: '/newsdetail/majorPartnership'
    },
    {
      img: '../assets/spec/news0630_1.png',
      time: '2025-06-30',
      bt: '校企携手，赋能未来来！甚湖科技与湖职共建人才基地',
      js: '2025年6月30日，湖州职业技术学院信息工程与物联网学院与浙江甚湖科技有限公司携手合作，正式授权并举行了校外实训基地授牌仪式。标志着双方在人才培养和实践教学方面的深入合作……',
      route: '/newsdetail/schoolEnterprise'
    },
    {
      img: '../assets/spec/news0513_1.png',
      time: '2025-05-13',
      bt: '浙江省供销社、新大集团领导赴甚湖科技、新甚科技参观指导',
      js: '2025年5月13日下午，浙江省供销社、新大集团领导一行莅临甚湖科技、新甚科技参观指导，深入生产一线参观调研，并与公司高层进行了座谈交流……',
      route: '/newsdetail/shenhuVisit'
    },

    {
      img: '../assets/spec/wt2.png',
      time: '2024-07-01',
      bt: '武汉大学半导体专委会厦门峰会，2024年6月28～29日在厦门国际会议中心举行!',
      js: '在2024年6月28日至29日，备受瞩目的武汉大学半导体专委会厦门峰会于厦门国际会议中心盛大举行。甚湖科技，作为科创联盟副理事长单位，踊跃参与了此次意义非凡的峰会……',
      route: '/newzz'
    },
    {
      img: '../assets/spec/wt3.png',
      time: '2024-06-24',
      bt: '转载：未来芯片发展关键方向！苹果积极布局玻璃基板芯片封装技术',
      js: '据媒体报道，苹果公司正积极与多家供应商商讨，将玻璃基板技术应用于芯片开发。据了解，玻璃基板具有耐高温的特性，能够让芯片在更长时间内保持峰值性能。同时，玻璃基板的超平整特性使其可以进行更精密的蚀刻，从而使元器件能够更加紧密地排列在一起，提升单位面积内的电路密度。玻璃基板的应用不……',
      route: 'https://baijiahao.baidu.com/s?id=1802711038204765769&wfr=spider&for=pc'
    },
    {
      img: '../assets/spec/wt4.png',
      time: '2024-04-29',
      bt: '转载：HBM内存、CoWoS封装的国产化替代思考：一个字 难！',
      js: '随着生成式人工智能（AI）的持续火爆，市场对于高性能AI芯片的需求，也带动了此类AI芯片内部所集成的高带宽内存（HBM）的需求爆发。根据市场研究机构Gartner的预测，2023年全球HBM营收规模约为20.05亿美元，预计到2025年将翻倍成长至49.76亿美元，增长率高达148.2%。作为HBM市场的领导……',
      route: 'http://www.xinhuanet.com/tech/20240429/957e9636b8274b81b12dea6c1aa395c1/c.html'
    },
    {
      img: '../assets/spec/wt1.png',
      time: '2023-04-08',
      bt: '全市第一季度“双招双引”工作推进暨招商引才特战队员座谈会召开!',
      js: '今天上午，市委书记陈浩主持召开全市第一季度“双招双引”工作推进暨招商引才特战队员座谈会。他强调，要深入学习贯彻习近平总书记在全国两会期间的重要讲话精神和考察浙江重要讲话精神，认真落实省、市“新春第一会”部署要求，牢牢把握经济建设这一中心工作和高质量发展这个首要任务，紧紧围绕能……',
      route: '/newwh'
    },
    {
      img: '../assets/spec/wt5.png',
      time: '2024-01-25',
      bt: '转载：继续推进摩尔定律！英特尔实现3D先进封装大规模量产',
      js: '今天，英特尔官方发布公告称，已实现基于业界领先的半导体封装解决方案的大规模生产，可在2030年后继续推进摩尔定律。这一进展不仅可以在芯片产品的性能、尺寸，以及设计应用的灵活性方面获得竞争优势，还将推动英特尔下一阶段的先进封装技术创新。英特尔表示，在其最新完成升级的美国新墨西哥州……',
      route: 'https://baijiahao.baidu.com/s?id=1789044390767614247&wfr=spider&for=pc'
    }
  ],
  news: {
    new1: '智启广交盛会 存储链接全球—浙江甚湖科技亮相第 140 届广交会',
    new2: '浙江甚湖科技赴绵阳考察，计划落地FC、SOP及陶瓷封装产线',
    new3: '重磅合作|甚湖科技携手行业龙头，共绘智能制造新蓝图',
    new4: '校企携手，赋能未来来！甚湖科技与湖职共建人才基地'
  },
  jd: {
    xw1: '转载：全市第一季度“双招双引”工作推进暨招商引才特战队员座谈会召开',
    xw2: '2024年04月08日',
    xw3: '今天上午，市委书记陈浩主持召开全市第一季度“双招双引”工作推进暨招商引才特战队员座谈会。他强调，要深入学习贯彻习近平总书记在全国两会期间的重要讲话精神和考察浙江重要讲话精神，认真落实省、市“新春第一会”部署要求，牢牢把握经济建设这一中心工作和高质量发展这个首要任务，紧紧围绕新能源汽车及关键零部件、半导体及光电等八大新兴产业链，重点再聚焦、机制再迭代、打法再创新，为发展新质生产力提供项目和人才支撑。<br/><br/>副市长金凯出席。会上，市商务局负责人汇报一季度全市招商引资（智）工作及市招商中心（特战队）工作情况；王捷、陈斌、沈云逸、范文垒、董玮玮、殷佳仕、沈文骏、屠涓等8位特战队员作交流发言。',
    xw4: '陈浩对去年以来全市“双招双引”工作表示肯定，向包括特战队员在内的广大招商干部表示感谢。他指出，从去年开始，每季度召开招商引才特战队员座谈会，复盘前阶段工作，分析新形势新问题，研究部署重点任务，已经成为我们抓“双招双引”工作的一项固定机制。一年多来，招商引才特战队紧紧围绕我市重点培育的八大新兴产业链，推动一大批优质项目和优秀人才落户湖州，为加快打造“六个新湖州”、高水平建设生态文明典范城市注入了强劲动能。肯定成绩的同时，也要清醒看到存在的问题和不足，有的放矢、补齐短板，确保新一年度“双招双引”工作取得更大成效。<br/><br/>陈浩强调，胸有全局才能开局破局。特战队员作为“双招双引”的尖刀兵，要站在融入长三角一体化发展、服务“双循环”格局等大战略大背景下，把握产业趋势和人才趋向，结合我市产业实际和未来发展方向，以长远眼光来审视和推进“双招双引”工作。谋有方向才能行稳致远。商务部门和特战队员要梳理跟踪新质生产力布局、“十五五”规划思路等重大战略，以前瞻性研究定方向、找赛道，寻求项目人才新的招引点和增长极。抓有办法才能突破争先。各地各部门要通过培育产业链、优化营商环境、提升科研水平来构建产业生态，更大力度招引一批我市发展所需的链主型企业、高科技项目和高素质人才。推有举措才能高效转化。要更好发挥商务部门的职能作用、特战队的“奇兵”作用、重大招商活动的引流作用、境内外驻点机构的枢纽作用，打好“一把手”招商、特战招商、链式招商、驻点招商、以商引商等组合拳，聚焦“投早投小投硬科技”，进一步提升项目和人才招引质效，为加快构建湖州特色现代化产业体系提供有力保障。',
    xw5: '会前，陈浩走访调研了去年由特战队员招引的浙江甚湖科技有限公司年产540万颗FcBGA&nbsp;项目、浙江慧仓智能科技有限公司年产10000台工业轮式机器人项目，了解两个项目建设进度，听取企业负责人对持续优化营商环境的意见建议，要求市级有关部门和属地党委政府聚焦项目全生命周期，用心用情做好服务保障，推动项目加快释放产能，助力经济高质量发展。',
  },
  jd1: {
    xw1: '武汉大学半导体专委会厦门峰会，2024年6月28～29日在厦门国际会议中心举行!',
    xw2: '2024年07月01日',
    xw3: '在2024年6月28日至29日，备受瞩目的武汉大学半导体专委会厦门峰会于厦门国际会议中心盛大举行。甚湖科技，作为科创联盟副理事长单位，踊跃参与了此次意义非凡的峰会。',
    xw4: '公司技术总监贾余良在峰会上着重介绍了甚湖科技在半导体先进封装和测试方面的创新成果与实践经验。其精彩的阐述不仅涵盖了技术的前沿探索，还包括了实际应用中的关键突破，获得了半导体联盟及高校半导体专委会同行的高度认可与赞誉。这一认可无疑对甚湖科技在半导体行业的影响力起到了强有力的积极推进作用，进一步巩固了甚湖科技在行业内的领先地位，为其未来的发展奠定了坚实基础。'
  },
  jd6: {
    title: '浙江省供销社及新大集团领导到甚湖科技有限公司参观指导',
    subTitle: '',
    lead: '2025年5月13日下午，浙江省供销社党委委员兼监事会主任童日晖及新大集团党委书记兼董事长林昌斌、党委副书记兼纪工何庆红一行到甚湖科技有限公司，深入开展参观调研活动，并与公司高层领导进行了深入的交流和座谈。',
    group: [
      {
        title: '参观半导体封装车间',
        xw1: '甚湖科技董事长林昌斌陪同童日晖主任和林总参观了公司的半导体封装车间。在参观过程中，童日晖详细介绍了车间生产流程、技术特点以及封装工艺的先进性。领导们对车间现代化管理和高效作业表示高度赞赏，并对甚湖科技在半导体封装领域的技术实力和创新能力给予了充分肯定。',
        imgPath1: 'news0602.png'
      },
      {
        title: '参观半导体模组车间',
        xw1: '随后领导们参观了甚湖科技的半导体模组车间，详细了解半导体模组生产流程、质量控制以及市场前景等方面的情况。童主任和林总对产线上展示的高科技产品和严格的质量控制流程表示了浓厚兴趣。甚湖科技是由新大集团与甚湖科技联合创立的科技企业，专注于半导体模组的研发与生产。此次领导的参观指导，不仅展示了双方合作的成果，也预示着未来在科技创新领域更深度的合作。',
        imgPath1: 'news0603.png'
      },
      {
        title: '座谈会召开',
        xw1: '参观结束后，双方在公司会议室举行了座谈。甚湖科技董事长兼总经理谢正军、副总裁朱总、常务副总经理王总出席了会议。会上，谢总首先对省供销社和新大集团领导的到来表示感谢，并介绍了公司的企业文化和未来发展方向。谢总强调，甚湖科技始终坚持科技创新为驱动，致力于成为半导体行业的领军企业。公司秉承“诚信、创新、合作、共赢”的理念，不断推动产品升级和市场拓展，为客户提供更优质的服务和产品。',
        imgPath1: 'news0604.png'
      },
      {
        title: '深入交流与合作展望',
        xw1: '在座谈会上，双方就行业发展趋势、企业合规模式、市场开拓策略等议题进行了深入交流。童主任和林总对甚湖科技的企业文化表示了充分的肯定，并就如何进一步提升企业竞争力、拓展市场等方面提出了宝贵意见和建议。童主任鼓励甚湖科技继续发挥自身优势，力争成为半导体行业的领军企业。',
        imgPath1: 'news0605.png'
      }
    ],
    summaryLead: '此次省供销社及新大集团领导的参观指导，加深了双方的了解，也为甚湖科技的未来发展注入了新的动力。甚湖科技将继续秉承开放合作的态度，与各界伙伴共同推动产业升级，为实现高质量发展而不懈努力。'
  },
  jd7: {
    title: '甚湖  · 湖职',
    subTitle: '校企携手赋能未来！',
    lead: '2025年6月30日，湖州职业技术学院信息工程与物联网学院与浙江甚湖科技有限公司携手合作，正式授权并举行了校外实训基地授牌仪式。标志着双方在人才培养和实践教学方面的深入合作。',
    group: [
      {
        title: '授牌仪式与实习生欢迎',
        xw1: '在授牌仪式上，湖州职业技术学院信息工程与物联网学院院长万杰一行莅临甚湖科技有限公司，共同见证了这一重要时刻。甚湖科技有限公司对学院14名实习生表示热烈欢迎。公司领导表示，通过与学院的合作，能够为公司注入新鲜血液，同时也为学生提供了一个实践和成长的机会。',
        imgPath1: 'news0703.png',
        xw2: '仪式结束后，学院的老师和学生参观了甚湖科技有限公司为员工和实习生准备的宿舍。公司对住宿条件的重视获得了师生的一致好评。良好的居住环境为实习生和员工提供了舒适的生活保障，有助于他们更好地适应工作和学习。',
        imgPath2: 'news0704.png'
      },
      {
        title: '新员工培训与部门培训',
        imgPath1: 'news0706.png',
        xw1: '2025年7月1日，人力资源部对新到的14名实习生进行了公司制度培训，确保他们能够快速融入公司文化，理解公司的运作流程。随后，生产部经理陈静对实习生进行了专业培训，涵盖了封装工艺、质量控制以及安全生产等方面的知识。陈静经理强调了理论与实践相结合的重要性，并鼓励实习生们积极提问，主动学习。',
        imgPath2: 'news0707.png',
        imgPath3: 'news0708.png',
        imgPath4: 'news0710.png'
      },
    ],
    summaryLead: '浙江甚湖科技有限公司与湖州职业技术学院的合作，不仅为学生提供了实践的平台，也为公司输送了新鲜的血液。甚湖科技有限公司将继续致力于与校企的合作，为社会培养更多优秀人才，为行业的发展贡献力量。'
  },
  jd8: {
    title: '甚湖科技携手行业龙头共绘智能制造新蓝图',
    subTitle: '万 物  皆   可 存 算',
    group: [
      {
        title: '',
        xw1: '本周，浙江甚湖科技有限公司迎来了立讯精密工业股份有限公司（股票代码：002475）莅临我司考察调研，并就深度合作达成重要共识。',
        imgPath1: 'news0803.png',
        xw2: '立讯精密工业股份有限公司成立于2004年，于2010年在深圳证券交易所中小企业板成功挂牌上市（股票代码：002475），作为全球领先的智能制造解决方案提供商，长期致力于为消费电子产品、汽车领域及企业通讯产品提供从核心零部件、模组到系统组装的一体化服务。',
        imgPath2: 'news0804.png',
        xw3: '甚湖科技正式承接其先进封装及SIP系统级封装订单，这标志着我们在高端电子制造服务领域的技术实力获得国际一流企业认可。双方将携手推进智能制造技术的创新应用，共同打造行业新标杆。',
        xw4: '在此之前，中国长城计算机集团公司与深圳桑达科技发展有限公司已先后莅临甚湖科技工厂参观调研。作为电子信息产业的国家队和地方骨干企业，两家单位的到访为双方建立紧密联系奠定了坚实基础，后续合作正在稳步推进中。',
        imgPath4: 'news0805.png',
        xw5: '行业龙头的信任与选择，是对甚湖科技技术实力、生产能力和服务水平的高度肯定。浙江甚湖科技有限公司将继续秉持“精工智造、合作共赢”的理念，以高标准、严要求服务每一位合作伙伴，为中国电子信息产业的高质量发展贡献力量！'
      }
    ]
  },
  jd9: {
    title: '绵阳考察团到访浙江甚湖科技开展招商对接',
    subTitle: '',
    group: [
      {
        title: '',
        xw1: '9月17日，浙川东西部协作产业链供应链合作绵阳活动暨知名浙江企业绵阳行产业合作恳谈会在四川绵阳举办。浙江甚湖科技总经理葛庆随浙江企业家考察团赴绵阳，深度开展实地调研与政企对接，计划在绵阳布局扩展 FC、SOP 及陶瓷封装产线，深化浙川半导体产业协同发展川观新闻。',
        imgPath1: 'news0901.png',
        xw2: '活动当日，考察团先后走访中国（绵阳）科技城创新馆、九洲集团、四川省具身智能机器人训练场。在各参访点位，葛庆与同行企业家一同实地观摩绵阳科技产业成果，围绕半导体技术路线、产业配套、本地龙头企业协同等关键议题，与当地相关负责人开展深入交流，切身感受绵阳雄厚的科教资源、完备的产业基础。',
        imgPath2: 'news0902.png',
        xw3: '在恳谈会前期的政企面对面对接洽谈环节，各县（市、区）、园区“一把手”与企业代表围桌而坐，直奔合作议题，高效推进产业对接。葛庆代表浙江甚湖科技与绵阳招商、产业园区相关方面开展深度磋商，就项目落地条件、厂房载体、产业协同等具体事项交换意见。',
        xw4: '葛庆表示，绵阳具备突出的区位优势，拥有长虹等一批电子信息领域龙头企业，与甚湖科技半导体封装业务具备高度契合度，是企业向西布局拓展的理想选择。“我们计划在绵阳扩展 FC、SOP 及陶瓷封装产线，本次行程已经实地踏勘多处现有厂房载体，接下来我们将加快细化方案，全力推动项目尽快落地实施。',
        xw5: '作为专注高端存储芯片先进封装测试的高新技术企业，浙江甚湖科技核心团队深耕半导体封测行业二十余年，具备 FC、SOP、陶瓷封装、多层芯片叠加封装等成熟技术能力，可为客户提供存储芯片封装测试一体化解决方案。本次意向布局绵阳，是企业响应浙川东西部协作号召，打通 “东部技术 + 西部产业市场” 的重要战略布局。',
        imgPath5: 'news0903.png',
        xw6: '下一步，甚湖科技将持续跟进各项对接成果，细化产线建设规划，加速推进项目前期各项工作，力争早日把意向转化为实实在在的产业产能，书写浙川产业链供应链协同合作新篇章。',
      }
    ]
  },
  iconic: {
    ico0: '特种计算机',
    ico1: '工业级应用',
    ico2: '数据中心',
    ico3: '超算中心',
    ico4: 'AI终端',
    ico5: '服务器',
    ico6: '笔记本',
    ico7: '相机',
    ico8: '无人机',
    ico9: '车规级',
    ico10: 'FCBGA多功能芯片',
    ico11: 'FCCSP系统级芯片',
    ico12: '网络设备',
    ico13: '手机',
    ico14: '高端计算设备',
    ico15: '先进显示技术',
    ico16: '消费电子',
    ico17: '智能穿戴设备',
    ico18: '高端计算设备',
    ico19: '汽车电子',
  },
  table: {
    th1: '接口',
    th2: '尺寸',
    th3: '最大顺序读取速度',
    th4: '最大顺序写入速度',
    th5: '容量',
    th6: '认证',
    th7: '工作电压',
    th8: '工作温度',
    th9: '应用方向',
    th10: '封装类型',
    th11: '封装尺寸(mm)',
    th12: '工作电压',
    th13: '工作温度',
    th14: '储存温度',
  },
  Special: {
    name: 'Special Conn SSD',
    tip: '可靠保障，安全护航',
    ys: '支持128GB~16TB容量，高可靠性能，读写速度快，保证数据稳定高效传输，为工业、汽车和商业存储市场提供了更多的可靠性。',
    th1: 'SATA转SAS、U.2、U.3、U.6等',
    th2: '客供尺寸要求',
    th3: '320~1000MB/s',
    th4: '250~800MB/s',
    th5: '128GB~16TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V~24V，VCCQ=1.8V~12V',
    th8: 'Consumer grade：0℃~70℃、<br/>-20℃~85℃、<br/>-40℃~105℃',
    th9: '特种计算机、工业级应用',
  },
  NVME: {
    name: 'U.2 NVME(数据盘)',
    tip: '企业级SSD，服务未来',
    ys: '512GB~16TB容量，读写速度快，高效传输，为数据中心、超算中心、AI算力平台提供更多的可靠产品。',
    th1: 'U.2 NVMe',
    th2: '2.5寸',
    th3: '1500~3000MB/s',
    th4: '1200~2700MB/s',
    th5: '512GB~16TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃',
    th9: '数据中心、超算中心、AI算力平台',
  },
  SATA: {
    name: '2.5寸 SATA',
    tip: '可靠保障，安全护航',
    ys: '用闪存存储技术的硬盘，具有更快的读写速度和更低的能耗。它适用于需要快速启动和加载应用程序的场景。支持128GB~16TB容量段，标准外形尺寸是 2.5 英寸,接口为SATA3.0。',
    th1: 'SATA3.0',
    th2: '2.5寸',
    th3: '500MB/s',
    th4: '450~480MB/s',
    th5: '128GB~16TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃、-20℃~85℃',
    th9: 'PC、服务器',
  },
  M2SATA: {
    name: 'M.2 SATA',
    tip: '可靠稳定、兼容性强',
    ys: '基于SATA 3.0，采用M.2 SATA3.0接口，多尺寸结构，兼容性强，稳定可靠，它们具有较长的寿命和较低的故障率，能够保证您的数据安全。M.2 SSD 通过 M.2 插槽连接至主板上，适用用于空间有限的超极本和平板电脑。',
    th1: 'M.2 2280、2260、2242 SATA',
    th2: '22mm×80mm、22mm×60mm、22mm×42mm',
    th3: '500MB/s',
    th4: '420MB/s',
    th5: '128GB~2TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃、-20℃~85℃',
    th9: 'PC、服务器',
  },
  M2PCIE: {
    name: 'M.2 PCIe',
    tip: '流畅、高效的数据存储与传输体验',
    ys: '采用先进的 M.2 接口标准，具备出色的兼容性，可广泛适配各类主流主板与设备。PCIe 技术的加持使其拥有极快的数据传输速度，无论是大文件的快速读写，还是多任务数据处理时的高速响应，都表现卓越。其紧凑的 M.2 外形设计，在节省空间的同时，也为设备内部结构的优化提供了便利。',
    th1: 'M.2 2280、2260、2242、2232 PCIe',
    th2: '22mm×80mm、22mm×60mm、22mm×42mm、22mm×30mm',
    th3: '1200~2700MB/s',
    th4: '950~1600MB/s',
    th5: '128GB~2TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃、-20℃~85℃',
    th9: 'PC、服务器、PAD',
  },
  mSATA: {
    name: 'm SATA',
    tip: '高速传输，强大储存能力',
    ys: '稳定读写，耐宽温，可做三防处理。',
    th1: 'm SATA',
    th2: '50mm×30mm',
    th3: '500MB/s',
    th4: '420MB/s',
    th5: '128GB~2TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃、-20℃~85℃',
    th9: 'PC、服务器、加固笔记本',
  },
  SD: {
    name: 'SD卡',
    tip: '数据安全性较好，运用广泛',
    ys: '不占太多空间，易于携带和安置在各种设备中。有不同容量规格，8GB～2TB ，适应不同用户的存储需求。在正常使用情况下能较好地保护存储的数据，可以稳定地进行数据的读取和写入操作，能与众多电子设备兼容。',
    th1: '',
    th2: '32mm×24mm',
    th3: '40~150MB/s',
    th4: '40~120MB/s',
    th5: '8GB～1TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：-25℃~85℃',
    th9: '相机、无人机、车载视频机',
  },
  YD: {
    name: '便携式移动硬盘',
    tip: '即插即用，海量的存储空间',
    ys: '容量范围在，256GB～4TB，使用Type-C & USB接口，即插即用，适合PC、手机等配备USB、Type-C接口的终端产品，支持在不同设备间转移数据，通常可以与多种操作系统兼容，如 Windows、Mac 等，方便不同平台用户使用。',
    th1: 'Type-C、USB',
    th2: '多种外观可选',
    th3: '500MB/s & 1000MB/s & 2000MB/s',
    th4: '450~480MB/s & 900MB/s & 1800MB/s',
    th5: '256GB～4TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=3.3V，VCCQ=1.8V',
    th8: 'Consumer grade：0℃~70℃',
    th9: '个人数据存储',
  },
  WBBGA: {
    name: 'WBBGA',
    tip: '高集成度，高性能',
    ys: '一种将多个芯片集成在一个封装中的技术，可以将多个芯片集成在一个封装中，实现更高的功能集成。采用晶圆级封装技术，封装尺寸较小，适用于对尺寸有要求的应用场景。由于芯片之间的距离较短，信号传输速度快，能够提高系统的性能。先进的封装技术可以提高芯片的可靠性，降低故障率。',
  },
  eMMC: {
    name: 'eMMC',
    tip: '先进工艺技术，高集成度大容量',
    ys: '遵循JEDEC eMMC5.0/5.1标准, 将MMC接口、快闪存储器设备及主控制器封装于一个小型BGA上，显著减少主机处理器上的存储管理负载。支持8GB~256GB容量段。具有快速、可升级的性能，同时其接口电压可以是1.8v或者是3.3v。超强兼容性，快速处理与主控制器及闪存的技术兼容问题。',
    th1: 'eMMC 5.0 & eMMC 5.1',
    th2: '11.5mm×13mm×1.00mm',
    th3: '160-270MB/s',
    th4: '70-210MB/s',
    th5: '8GB~128GB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=2.7~3.6V，VCCQ=1.7~1.95V/2.7~3.6V',
    th8: 'Consumer grade：-20℃~85℃',
    th9: 'PC、服务器',
  },
  UFS: {
    name: 'UFS',
    tip: '存储之星，新一代高速大容量存储芯片',
    ys: '遵循JEDEC UFS3.1国际标准，兼容UFS2.2/2.1，支持128GB~1TB容量，将UFS接口、快闪存储器及主控制器，都集成在一个小型的BGA 封装内。UFS的串行数据传输技术具备高速度、高可靠性，抗干扰能力强，并能显著减少主机处理器上的存储管理负载。',
    th1: 'MIPI M-PHY',
    th2: '11mm×13mm×1.00mm',
    th3: '1200MB/s',
    th4: '70-210MB/s',
    th5: '64GB~128GB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=1.8~3.3V，CCQ=1.7~1.95V/2.7~3.6V',
    th8: 'Consumer grade：-20℃~85℃',
    th9: 'PC、服务器',
  },
  Nand: {
    name: 'Nand Flash',
    tip: '支持多个晶圆的存储芯片',
    ys: '遵循JEDEC JESD230C国际标准，标准封装132/252球BGA，支持32GB~1TB容量段，支持原主流晶圆。它可以在一个颗粒中封装1-16个晶片。产品分为单渠道、双渠道和四渠道。单通道和双通道Nand适用于U盘和SSD；四通道Nand适用于M.2 2230 SSD产品。',
    th1: 'Parallel Nand',
    th2: '8mm×6mm',
    th3: '200MB/s',
    th4: '150MB/s',
    th5: '8GB~256GB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=1.8~3.3V',
    th8: 'Consumer grade：-20℃~85℃',
    th9: 'PC、服务器',
  },
  UDP: {
    name: 'UDP (黑豆干)',
    tip: '支持多晶圆多接口的黑胶体存储盘',
    ys: '遵循JEDECUSB3.0/2.0国际标准，UDP标准黑胶体U盘尺寸。单USB口，USB+MircoUSB,USB+Type-C。支持16GB~512GB容量段。黑胶体U盘体积小，质量轻，具有三防功能。',
    th1: 'USB2.0、3.0',
    th2: '2CM×1.1CM、4CM×1.1CM',
    th3: '20MB/s＝USB2.0、80MB/s＝USB3.0',
    th4: '10MB/s＝USB2.0、30MB/s＝USB3.0',
    th5: '1GB~1TB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=1.3~1.8V',
    th8: 'Consumer grade：0℃~60℃',
    th9: 'PC、Phone、工控机等',
  },
  Micro: {
    name: 'Micro SD card',
    tip: '支持多晶圆大容量存储卡',
    ys: '遵循SD 6.0协议，向下兼容，速度等级有Class 2、Class 4、Class 6、Class 10、UHS-I、A1、A2、V60、V90等标准，支持512MB~512GB容量段。支持颗粒制程有SLC,MLC,TLC,QLC。具有小体积，大容量，高稳定性的。',
    th1: 'SD',
    th2: '15mm×11mm×1.00mm',
    th3: '15MB/s',
    th4: '6-7MB/s',
    th5: '8GB~256GB',
    th6: 'CE、3C、FCC、ROHs',
    th7: 'VCC=2.7~3.6V，VCCQ=1.7~1.95V/2.7~3.6V',
    th8: 'Consumer grade：-20℃~85℃',
    th9: 'PC、服务器',
  },
  FCBGA: {
    name: 'FCBGA',
    tip: '可靠，高抗弯强度',
    ys: '倒装芯片球栅阵列，它采用了倒装芯片技术，FCBGA封装可以提供较好的电气特性，并且大幅地提高接脚密度，降低干扰，提高散热性能，还可缩小封装尺寸，借此满足高端产品和高性能产品的需求。',
  },
  FCCSP: {
    name: 'FCCSP',
    tip: '高密度、高性能',
    ys: '采用了倒装芯片技术，可以在较小的面积内集成更多的芯片，提高了封装的密度。运用接近裸芯片尺寸的封装，从而减小了封装体积，适用于对尺寸有严格要求的应用场景，如移动设备等。倒装芯片连接方式可以减少信号传输路径的长度和损耗，提高了信号的传输速度和质量。',
  },
  DD: {
    name: '2.5D',
    tip: '高性能、更小尺寸和更可靠运行',
    ys: '介于传统2D平面和真正3D立体结构之间的一种形式，具有一定的立体特性。能更好地整合多种不同功能的芯片或器件。能优化性能，如可以改善信号传输效率和散热性能等。',
  },
  TD: {
    name: '3D',
    tip: '高效信号传输、多样化功能融合',
    ys: '3D立体结构可以将多个不同功能的组件集成在一个立体空间内，实现更高的集成度。有效节省空间，使电子设备更加轻薄便携。通过更短的信号传输路径，减少信号延迟和损耗，提升性能。能将处理器、传感器、存储等多种功能模块紧密结合。',
  },
  dy: {
    title: '在线留言',
    desc: '请填写以下信息，我们将尽快与您联系',
    optional: '选填',
    type: '咨询类型',
    typePlaceholder: '请选择咨询类型',
    typeProduct: '产品咨询',
    typeBusiness: '商务合作',
    typeSupport: '技术支持',
    typeOther: '其他',
    company: '公司名称',
    companyPlaceholder: '请输入公司名称',
    contact: '联系人',
    contactPlaceholder: '请输入联系人姓名',
    email: '电子邮箱',
    emailPlaceholder: '请输入常用邮箱，如 name@company.com',
    phone: '联系电话',
    phonePlaceholder: '请输入联系电话（选填）',
    product: '意向产品',
    productPlaceholder: '如 eMMC / UFS / SSD / 先进封测服务',
    message: '留言内容',
    messagePlaceholder: '请简要描述您的需求，便于我们安排对应的同事与您联系',
    submit: '提交留言',
    submitting: '提交中…',
    privacy: '我们仅将您填写的信息用于本次业务沟通，不会对外公开',
    successTip: '提交成功，我们会尽快与您联系',
    submitFailTip: '提交失败，请稍后重试或直接发送邮件联系我们',
    errorTip: '请检查标红的必填项',
    errRequired: '此项为必填项',
    errEmail: '邮箱格式不正确，请检查',
    errPhone: '电话格式不正确，请检查',
  },
  newli: {
    lu1: '消费级SSD',
    lu2: '企业级SSD',
    lu3: '工业控制级SSD',
    lu4: '数据中心级SSD',
    lu5: '嵌入式存储',
    lu6: '前置存储',
    lu7: '消费级存储卡',
    lu8: '内存条',
    lu9: '消费电子',
    lu10: '移动闪存',
    lu11: '智慧闪存',
    lu12: '智慧PSSD',
    lu13: 'SkyBox',
    lu14: '企业级主机',
    lu15: '全闪NAS',
    lu16: 'DeepSeek桌面服务器',
    lu17: 'Desktop机架式服务器',
    lu18: '消费级存储卡',
  },
  tdtr: {
    tr0: '终身',
    tr1: '原有型号',
    tr2: '产品型号',
    tr3: '接口规格',
    tr4: '介质类型',
    tr5: '容量规格(GB)',
    tr6: '顺序读/写最大(MB/s)',
    tr7: '随机读/写最大(IOPS)',
    tr8: '最大功耗',
    tr9: 'MTBF(小时)',
    tr10: '尺寸(mm)',
    tr11: '重量(g)',
    tr12: '工作温度',
    tr13: '存储温度',
    tr14: '工作湿度',
    tr15: '有限固保',
    tr16: '尺寸(mm)',
    tr17: '协议标准',
    tr18: '频率(MHz)',
    tr19: '引脚',
    tr20: '电压(V)',
    tr21: '系统支持',
    tr22: '传输速度',
    tr23: '颜色',
    tr24: '产品类别',
    tr25: '特点',
    tr26: 'CPU架构',
    tr27: 'CPU频率',
    tr28: '内存',
    tr29: '系统存储',
    tr30: '存储',
    tr31: '硬盘插槽',
    tr32: '数据保护',
    tr33: 'USB接口',
    tr34: '网络接口',
    tr35: '电源接口',
    tr36: '前置接口',
    tr37: '后置接口',
    tr38: '无线网络',
    tr39: 'DeepSeek',
    tr40: '吞吐量/并发',
    tr41: '重量',
    tr42: '电压电源',
    tr43: 'PCIe扩展',
    tr44: '其他接口',
    tr45: '网络',
    tr46: '机箱尺寸(mm)',
    tr47: '机箱',
  },
  newSATA: {
    tip: '高速读写、数据安全',
    ys: '消费级SSD专为笔记本电脑、台式机及一体机等消费电子设备设计，通过革新性的数据传输速度有效提升家用电脑的游戏体验与图形处理效率。技术层面，甚湖科技采用先进的主控芯片与3D NAND Flash颗粒，结合自主研发的NAND Flash管理软件，实现高速读写与数据安全保障。生产环节依托全自动化产线制造，严格执行振动、高低温等极端环境测试标准，确保产品长期稳定运行。',
  },
  newQz: {
    tip: '',
    ys: '甚湖科技存储卡搭载独有的微智能功能，可实现性能监测、寿命预警和读写锁定，全面提升数据安全性与使用便捷性。产品专为视频监控环境打造，支持 7×24 小时不间断录像，其寿命、稳定性和擦写次数远超市面上的普通存储卡，可为客户提供更长生命周期的存储解决方案，确保关键数据的持续稳定存储。'
  },
  newNc: {
    tip: '支持ECC纠错、保障数据稳定',
    ys: '甚湖科技内存类产品，采用高品质原装IC，容量8GB-64GB，100%经过主机严格测试，确保稳定性和性能。产品支持JEDEC标准1.2V（1.14V~1.26V），符合RoHS标准、CE / FCC认证。经过Intel/AMD全平台兼容认证，企业级型号更是支持ECC纠错，有效保障数据稳定。终身质保与低功耗设计，满足电竞、设计、工控及专业计算等高性能场景需求，助力实现持久高速响应。'
  },
  newNas: {
    tip: '',
    ys: '甚湖科技“闪存+”，不仅服务于个人和家庭用户，同时也为众多的企业用户赋能。全闪存NAS，AI主机为企业发现新用户、开拓新市场、探究新模式，创造更多开源可能。同时，基于历史数据分析的流程优化、分工细化、人员复用，为企业降本提供基础。',
  },
  newCp: {
    cp1: '英特尔® N100',
    cp2: '英特尔® 酷睿™ i3-1215U',
    cp3: '4核4线程，睿频可达3.20 GHz',
    cp4: '6核8线程，睿频可达4.40GHz',
    cp5: '默认',
    cp6: '无凝结',
    cp7: '年',
    cp8: '兼容',
  },
  newU: {
    name: 'U盘',
    name1: '移动硬盘',
    name2: '固态U盘',
    zd: 'USB可折叠隐藏',
    col1: '金属色',
    col2: '黑银',
    col3: '墨灰',
    col4: '银色',
    col5: '黑色',
    col6: '星空灰/黑金',
  },
  specia: {
    sp1: '支持',
    sp2: '隐私',
    sp3: '备份',
    sp4: '加密',
    sp5: 'AMD Strix Halo，锐龙 AI Max+ 395, 16核32线程, 40CU GPU',
    sp6: '128GB, LPDDR5, 8000MHz, 板载',
    sp7: '读卡器',
    sp8: '用户',
    sp9: '推理',
    sp10: 'AMD Strix Halo，锐龙 AI Max+ 395, 16核32线程, 40CU GPU',
    sp11: '前置：24x2.5”SAS/SATA或最高支持8x2.5”NVMe U.2 SSD',
    sp12: '内置：板载支持2个SATA M.2 SSD',
    sp13: '支持12个标准PCIe 扩展插槽',
    sp14: '2个VGA接口，1个位于机箱后部，1个位于机箱前部',
    sp15: '4个USB 接口，2个位于机箱后部、2个位于机箱前部',
    sp16: '1 个RJ-45 管理接口位于机箱后部',
    sp17: '1个RJ45管理口，可选1个OCP3.0网卡，支持标准PCIe网卡',
    sp18: '175.8mm（高）×446mm（宽）×798mm（深）',
    sp19: '19英寸4U机架式标准机箱',
    sp20: '100/240V，支持2+2冗余',
    sp21: '10％-90％相对湿度，无凝露',
  },
}



// WEBPACK FOOTER //
// ./src/lang/zh.js